import { render, staticRenderFns } from "./CommonTableModal.vue?vue&type=template&id=65b9d75e&"
import script from "./CommonTableModal.vue?vue&type=script&lang=js&"
export * from "./CommonTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports